var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: _vm.updataOrview == 2 ? "查看自定义功能" : "编辑自定义功能",
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            confirmButtonText: "确定",
            "append-to-body": "",
          },
          on: {
            open: _vm.open,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { key: "functionType", attrs: { prop: "function_type" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("功能类型")]),
                  ]),
                  _c("v-radio", {
                    staticClass: "options",
                    attrs: {
                      disabled: "",
                      name: "functionType",
                      options: _vm.functionTypeOptions,
                    },
                    on: { change: _vm.typeChange },
                    model: {
                      value: _vm.functiontype,
                      callback: function ($$v) {
                        _vm.functiontype = $$v
                      },
                      expression: "functiontype",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { key: "name", attrs: { prop: "name" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("功能名称")]),
                  ]),
                  _c("v-input", {
                    attrs: {
                      type: "text",
                      disabled: _vm.updataOrview == 2,
                      name: "name",
                    },
                    model: {
                      value: _vm.ruleForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "name", $$v)
                      },
                      expression: "ruleForm.name",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { key: "identifier", attrs: { prop: "identifier" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("标识符")]),
                  ]),
                  _c("v-input", {
                    attrs: {
                      type: "text",
                      disabled: _vm.updataOrview == 2,
                      name: "identifier",
                    },
                    model: {
                      value: _vm.ruleForm.identifier,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "identifier", $$v)
                      },
                      expression: "ruleForm.identifier",
                    },
                  }),
                ],
                2
              ),
              _vm.functiontype == "properties"
                ? _c(
                    "v-form-item",
                    { key: "data_type", attrs: { prop: "data_type" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("span", { staticClass: "required" }, [_vm._v("*")]),
                        _c("span", [_vm._v("数据类型")]),
                      ]),
                      _c("v-select", {
                        attrs: {
                          disabled: _vm.updataOrview == 2,
                          id: "data_type",
                          insertContains: "data_type",
                          name: "data_type",
                          options: _vm.dataTypeOptins,
                        },
                        model: {
                          value: _vm.ruleForm.data_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "data_type", $$v)
                          },
                          expression: "ruleForm.data_type",
                        },
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.functiontype == "service"
                ? _c(
                    "v-form-item",
                    {
                      key: "input_data",
                      attrs: { prop: "input_data", required: false },
                    },
                    [
                      _c("template", { slot: "label" }, [
                        _c("span", { staticClass: "required" }),
                        _c("span", [_vm._v("输入参数")]),
                        _c(
                          "div",
                          { staticClass: "handle-button" },
                          [
                            _c(
                              "v-button",
                              {
                                attrs: {
                                  disabled: _vm.updataOrview == 2,
                                  size: "S",
                                  type: "text",
                                  name: "btn12",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openAddModel("input")
                                  },
                                },
                              },
                              [_vm._v("+增加参数")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._l(_vm.ruleForm.input_data, function (item, index) {
                        return _c("div", { key: index }, [
                          _c("div", { staticClass: "parameter mb10" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(item.identifier) +
                                  "：" +
                                  _vm._s(item.name)
                              ),
                            ]),
                          ]),
                          _c("span", { staticClass: "parame-edit-del" }, [
                            _c(
                              "span",
                              {
                                class:
                                  _vm.updataOrview != 2 ? "handle-button" : "",
                              },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn3",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openUpdateModel(
                                          item,
                                          index,
                                          "input"
                                        )
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.updataOrview == 2 ? "查看" : "编辑"
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _vm.updataOrview != 2
                                  ? _c(
                                      "v-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          size: "S",
                                          type: "text",
                                          name: "btn4",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delParam(index, "input")
                                          },
                                        },
                                        slot: "reference",
                                      },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ])
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.functiontype != "properties"
                ? _c(
                    "v-form-item",
                    {
                      key: "output_data",
                      attrs: { prop: "output_data", required: false },
                    },
                    [
                      _c("template", { slot: "label" }, [
                        _c("span", { staticClass: "required" }),
                        _c("span", [_vm._v("输出参数")]),
                        _c(
                          "div",
                          { staticClass: "handle-button" },
                          [
                            _c(
                              "v-button",
                              {
                                attrs: {
                                  size: "S",
                                  disabled: _vm.updataOrview == 2,
                                  type: "text",
                                  name: "btn2",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openAddModel("output")
                                  },
                                },
                              },
                              [_vm._v("+增加参数")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._l(_vm.ruleForm.output_data, function (item, index) {
                        return _c("div", { key: index }, [
                          _c("div", { staticClass: "parameter mb10" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(item.identifier) +
                                  "：" +
                                  _vm._s(item.name)
                              ),
                            ]),
                          ]),
                          _c("span", { staticClass: "parame-edit-del" }, [
                            _c(
                              "span",
                              {
                                class:
                                  _vm.updataOrview != 2 ? "handle-button" : "",
                              },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn2",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openUpdateModel(
                                          item,
                                          index,
                                          "output"
                                        )
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.updataOrview == 2 ? "查看" : "编辑"
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _vm.updataOrview != 2
                                  ? _c(
                                      "v-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          size: "S",
                                          type: "text",
                                          name: "btn2",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delParam(index, "output")
                                          },
                                        },
                                        slot: "reference",
                                      },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ])
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "v-form-item",
                { key: "desc", attrs: { prop: "desc", required: false } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }),
                    _c("span", [_vm._v("备注")]),
                  ]),
                  _c("v-input", {
                    staticClass: "Description",
                    attrs: {
                      type: "textarea",
                      disabled: _vm.updataOrview == 2,
                      name: "desc",
                      maxlength: 200,
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.ruleForm.desc,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "desc", $$v)
                      },
                      expression: "ruleForm.desc",
                    },
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c("v-loading", {
            staticClass: "loading-box",
            attrs: { visible: !_vm.upTips, name: "loading4" },
          }),
        ],
        1
      ),
      _c("AddParam", {
        ref: "add",
        attrs: { showInputDialog: _vm.addloading, ParamData: _vm.ParamData },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.addloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.addloading = $event
          },
          changeinputDataList: _vm.changeinputDataList,
        },
      }),
      _c("UpdateParam", {
        ref: "Update",
        attrs: {
          showInputDialog: _vm.Updateloading,
          updataOrview: _vm.updataOrview,
          propData: _vm.propData,
          ParamData: _vm.ParamData,
          updateIndex: _vm.updateIndex,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.Updateloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.Updateloading = $event
          },
          updatainputDataList: _vm.updatainputDataList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }